<template>
<div>
    <div @click="showModal">
        <img slot="aside" :src="'/src/assets/FotoTovarov/'+item.Code+'.jpg'" alt="Media Aside" />
    </div>
    <b-modal id="modal-center" ref="myModalRef" hide-footer :title="'Код товара: '+item.Code">
        <div class="d-block text-center">
            <b-media>
                <img slot="aside" :src="'./src/assets/FotoTovarov/'+item.Code+'.jpg'" alt="Media Aside" />

            </b-media>

            <p><strong>Описание: </strong><br>{{ item.Name }}</p>
            <br>
            <h5>Стоимость: <strong>{{ getPrice(item.Price.toString()) }}
                <i class="fa fa-rub" area-hidden="true"></i>
                </strong></h5>

        </div>
        <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Закрыть</b-btn>
        <b-btn class="mt-3" variant="info" block @click="addCart" :disabled="inCart != -1">{{ inCart != -1 ? 'В корзине' : 'Добавить в корзину'}}</b-btn>

        <b-btn variant="outline-primary" class="mt-3" block v-clipboard:copy="copied" v-clipboard:success="handleSuccess" :disabled="copyStatus">
            {{copyStatus ? 'Ссылка скопирована':'Скопировать ссылку страницу описания'}}
        </b-btn>
        <router-link tag="a" class="m-3" target="_blank" :to="{name:'productId',params:{id:item.Code}, query:{tbl:'ligasound'}}">Открыть в новой вкладке</router-link>
    </b-modal>
</div>
</template>

<script>
export default {
    props: ['item'],
    data() {
        return {
            thingToCopy: ``,
            copyStatus: null

        }
    },
    methods: {
        showModal() {
            this.$refs.myModalRef.show()
        },
        hideModal() {
            this.$refs.myModalRef.hide()
        },
        handleSuccess() {
            this.copyStatus = true
        },
        getPrice(price) {
            let reg = /(\d)(?=(\d\d\d)+([^\d]|$))/g
            return price.replace(reg, '$1 ')
        },
        addCart() {
            let data = {}
            data.id = this.item.Code
            data.short = this.item.Name
            data.img = './src/assets/FotoTovarov/' + this.item.Code + '.jpg'
            data.price = this.item.Price
            data.nal = 'true'
            data.count = 1
            data.sklad = 'ligasound'
            this.$store.commit('cart/add', data)
            this.hideModal()
        }
    },
    computed: {
        inCart() {
            let arr = this.$store.getters['cart/inCart']
            return arr.indexOf(this.item.Code)
        },
        copied(){
            return this.thingToCopy = `https://ligasound.ru/product/${this.item.Code}?tbl=ligasound`
        }
    }
}
</script>

<style scoped>
.media {
    align-items: center;
    flex-wrap: wrap;
}

img {
    max-width: 100%;
    max-height: 300px;
}

p {
    text-align: justify;
    margin: 5px;
}

@media(max-width: 560px) {
    .url {
        text-align: center;
    }
}
</style>
